<template lang="pug">
.goods-list
  .discount-tip 针对特定客户、商品类目设置定向优惠，双方确认后生效。在买家生成订单时，可在成交价（含会员权益）的基础上叠加减免。如有异议，请联系胖猫网客服
  .tabs-container
    el-tabs(v-model="searchData.status" @tab-click="changeTab")
      el-tab-pane(v-for="item, index in discountTabs" :key="index" :name="item.name" :label="item.label")
  el-table.table(:data="list"
    :header-cell-style="{'font-size': '12px', background: '#f2f2f2', color: '#333'}")

    el-table-column(label="买家抬头" prop="orgName" align="left" min-width="140px")
    el-table-column(label="优惠政策" prop="promotionDetailResultList" align="center" min-width="200px")
      template(slot-scope="scope")
        div(v-for="(item, index) in scope.row.promotionDetailResultList" :key="index") {{item.entityName}}     减免金额：{{item.value/100}}元/{{item.unitDesc}}
    el-table-column(label="买家最新确认时间" prop="creatorTime" align="center")
      template(slot-scope="scope") {{scope.row.creatorTime | dateFormat}}
    el-table-column(label="双方确认状态" prop="status" align="center")
      template(slot-scope="scope") {{scope.row.status | grantStatusText}}
      //- 1 买家未确认 2 卖家未确认 3 生效中 4 已失效
        //- el-button.btn-text(type="text" @click="confirm") 确认
    el-table-column(label="商家确认人" align="center" prop="grantorName")
    el-table-column(label="商家确认人手机号" align="center" prop="grantorPhone")
    el-table-column(label="商家确认时间" align="center" prop="grantTime")
      template(slot-scope="scope") {{scope.row.grantTime | dateFormat}}
    el-table-column(label="操作" width="100px" class-name="operate")
      template(slot-scope="scope")
        el-button.btn-text(v-if="scope.row.status === 20" type="text" @click="confirm(scope.row)") 确认

  el-pagination.pagination(background :page-size="searchData.pageSize" v-if="listCount > 0"
    :page-sizes="[20, 40, 80, 120]" @size-change="handleSizeChange"
    :current-page="searchData.pageNo" layout="total, sizes, prev, pager, next, jumper" prev-text="上一页"
    :total="listCount" @current-change="getList" next-text="下一页")

  el-dialog(title="确认定向优惠" :visible.sync="confirmDialog" width="520px" center)
    .no-permission(v-if="!dialogPermission")
      div 必须是企业在胖猫网的授权人才能同意定向优惠政策。
      div 企业授权人：{{grantorInfo.grantorName}} （{{grantorInfo.grantorPhone}}）
    el-form(label-width="120px" v-if="dialogPermission" label-position="left")
      el-form-item(label="授权人手机号：")
        el-input(v-model.trim="grantorInfo.grantorPhone" disabled placeholder="请输入授权人手机号")
          template(slot="append")
            el-button(
              class="get-code-btn"
              slot="append"
              @click="handleGetCode()"
              :disabled="isCountDown"
            ) {{ isCountDown ? countDown + 's' : '获取验证码' }}
      el-form-item(label="验证码：")
        el-input(v-model.trim="code" placeholder="请输入验证码")
      .div(style='color:#cd974c') *企业授权人确认定向优惠后立即生效，如有异议，请联系胖猫网客服。
    .dialog-footer(slot="footer" v-if="dialogPermission")
      el-button(@click="confirmDialog = false") 取 消
      el-button(type="primary" @click="submitConfirm") 确 认
    .dialog-footer(slot="footer" v-if="!dialogPermission")
      el-button(type="primary" @click="confirmDialog = false") 知道了

</template>

<script>
import dateFormat from '@/common/utils/date'
export default {
  name: 'discoountList',
  data() {
    return {
      list: [],
      listCount: 0,
      searchData: {
        status: '20',
        pageNo: 1,
        pageSize: 10
      },
      discountTabs: [
        {
          name: '20',
          label: '待确认'
        },
        {
          name: '30',
          label: '生效中'
        }
      ],
      dialogPermission: true,
      confirmDialog: false,
      countDown: 0,
      grantorInfo: {},
      code: ''
    }
  },
  computed: {
    isCountDown() {
      return this.countDown > 0
    }
  },
  filters: {
    grantStatusText(value) {
      return {
        10: '买家未确认',
        20: '卖家未确认',
        30: '生效中',
        40: '已失效'
      }[value]
    },
    dateFormat(value) {
      return dateFormat(value, 'YYYY-MM-dd HH:mm:ss', false)
    }
  },
  mounted() {
    this.getList()
  },
  activated() {
    this.getList()
  },
  methods: {
    async getList(page) {
      try {
        let { success, data } = await this.$get('promotion.getMerchantPromotionList', {
          merchantPromotionParam: this.searchData
        })
        if (success) {
          this.list = data[0].merchantPromotionVOList
          this.listCount = data[0].totalCount
        }
      } catch (error) {
        console.log(error)
      }
    },
    changeTab(item, evt) {
      if (!this.activeTab || this.activeTab !== item.name) {
        this.activeTab = item.name
        this.getList()
      }
    },
    handleSizeChange(val) {
      this.searchData.pageSize = val
      this.getList()
    },
    async confirm(row) {
      this.grantorInfo = row
      let { success, data } = await this.$get('promotion.checkSendSmsLimit', {
        sendSmsParam: {
          id: this.grantorInfo.id
        }
      })
      if (!success) return
      this.code = ''
      this.confirmDialog = true
      this.dialogPermission = data[0] && data[0].success
      // if (success) {
      //   this.confirmDialog = true
      // }else{
      //   this.dialogPermission = false
      // }
    },
    async submitConfirm() {
      let { success } = await this.$get('promotion.confirmPass', {
        confirmSmsCodeParam: {
          id: this.grantorInfo.id,
          code: this.code
        }
      })
      if (success) {
        this.$message.success('确认成功')
        this.confirmDialog = false
        this.getList()
      }
    },
    clearTimer() {
      this.timer && clearInterval(this.timer)
    },
    startCountdown() {
      this.countDown = 60
      this.timer = setInterval(() => {
        this.countDown-- || this.clearTimer()
      }, 1000)
    },
    async handleGetCode() {
      try {
        this.startCountdown()
        const result = await this.$get('promotion.sendConfirmPromotionSms', {
          sendSmsParam: {
            id: this.grantorInfo.id
          }
        })
        console.log(result)
        if (result.success) {
          this.$message.success('发送成功')
        } else {
          this.$message.error('获取短信失败')
        }
      } catch (e) {
        console.log('err:', e)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.goods-list
  .discount-tip
    color #cd974c
  .tabs-container
    position relative
    /deep/ .el-tabs__nav-wrap
      padding-right 360px
  .btn-text
    padding 0 5px !important
    font-size 12px

  /deep/.table
    th, td
      padding 2px 0
      font-size 13px
  /deep/.el-date-editor.el-input
    width 165px

  /deep/.operate
    .cell
      line-height 18px
      .el-button--text
        padding 5px
      .el-button+.el-button
        margin-left 0
.no-permission
  div
    line-height 24px
    margin-bottom 10px
/deep/.el-input-group__append {
  .get-code-btn {
    color: #ffffff;
    background-color: #f0242e;
    border-color: #f0242e;
    width 112px
  }
  .get-code-btn[disabled] {
    color: #909399;
    background-color: #f5f7fa;
    border-color: #f5f7fa;
  }
}
</style>
